module.exports = __webpack_public_path__ + "img/symbol_12.867e304e.png";